module.exports = __webpack_public_path__ + "img/thumbnail_SaltwaterCrocodile_m_albino.91f95321.png";